/**
 * ч.1442: віджети підпису для сторінок системи — Дія.Підпис (id.gov.ua) і хмарний ключ ІІТ.
 * Адреси приходять із сервера (тестове чи робоче середовище Дії — налаштування сервера).
 */
import { useQuery } from '@tanstack/react-query';
import { edoSign, type SignWidgets } from '@/api/edoSign';

export function useSignWidgets(): SignWidgets | undefined {
  return useQuery({
    queryKey: ['edo-sign-widgets'],
    queryFn: edoSign.widgets,
    staleTime: 60 * 60_000,
    retry: false,
  }).data;
}

/** Попередження під віджетом Дії в тестовому середовищі. */
export const DIIA_TEST_NOTE = 'Дію підключено в тестовому середовищі: тут підписують лише тестовими ключами. '
  + 'Звичайним ключем підпишіть на іншій вкладці.';
